/* eslint no-extend-native: 0 */

// This file runs before React and Next.js core
// This file is loaded for all browsers
// Next.js includes a number of polyfills only for older browsers like IE11
// Make sure you don't duplicate these in this file: https://bit.ly/2YHKkrp
import 'core-js/es/array'
import 'core-js/es/number'
import 'core-js/es/object'
import 'core-js/es/set'
import 'core-js/es/string'
import 'core-js/es/symbol'
import 'core-js/modules/web.dom-collections.for-each.js'
import 'core-js/modules/web.dom-collections.iterator.js'
import 'intersection-observer'
